import { type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Badge variant definitions.
 *
 * ### Variants
 * | variant     | description                                      |
 * |-------------|--------------------------------------------------|
 * | `default`   | Muted background with border — general purpose   |
 * | `accent`    | Gradient text (accent) — market links, highlights |
 * | `success`   | Green text — positive values                     |
 * | `danger`    | Red text — negative values                       |
 */
const badgeVariants = cva('inline-flex items-center font-sans whitespace-nowrap', {
  variants: {
    variant: {
      purple: 'text-purple font-semibold text-base underline',
      default: 'bg-border rounded-full px-2 py-0.5 text-xs font-semibold text-primary uppercase',
      accent: [
        'text-sm font-semibold underline',
        'bg-gradient-to-b from-accent to-accent-dark',
        'bg-clip-text text-transparent',
      ].join(' '),
      success: 'text-xs font-semibold text-success',
      danger: 'text-xs font-semibold text-danger-alt',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>;

export { badgeVariants };
